import PropTypes from 'prop-types';

import { Land, Nomination } from 'components/atoms/CustomSVGIcon';

const RegionItemHeader = ({ region, count }) => (
	<>
		<div className="CardHeader-icon RegionItemHeader">
			<Land className="Icon" />
		</div>
		<div className="CardHeader-title">
			{region.id} - {region.name}
		</div>
		<div className="CardHeader-indicators">
			<Nomination className="nominationIcon CampaignIcon" />
			<span className="CardHeader-indicators-item-count">{` ${count ? count : 0}`}</span>
		</div>
	</>
);

RegionItemHeader.propTypes = {
	count: PropTypes.number,
	region: PropTypes.object,
};

export default RegionItemHeader;
